import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPresentationTrendlineUpFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.59967 1.99992H10.3997C11.8931 1.99992 12.6399 1.99992 13.2103 2.29057C13.7121 2.54623 14.12 2.95418 14.3757 3.45594C14.6663 4.02637 14.6663 4.77311 14.6663 6.26659V7.73325C14.6663 9.22672 14.6663 9.97346 14.3757 10.5439C14.12 11.0457 13.7121 11.4536 13.2103 11.7093C12.6399 11.9999 11.8931 11.9999 10.3997 11.9999H5.59967C4.1062 11.9999 3.35946 11.9999 2.78903 11.7093C2.28727 11.4536 1.87932 11.0457 1.62366 10.5439C1.33301 9.97346 1.33301 9.22672 1.33301 7.73325V6.26658C1.33301 4.77311 1.33301 4.02637 1.62366 3.45594C1.87932 2.95418 2.28727 2.54623 2.78903 2.29057C3.35946 1.99992 4.1062 1.99992 5.59967 1.99992ZM5.24 9.482L7.849 6.377L6.701 5.413L4.092 8.518ZM6.648 6.306L8.097 8.516L9.351 7.694L7.902 5.484ZM9.298 8.587L11.907 5.482L10.759 4.518L8.15 7.623Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 1.99992V1.33325M3.99967 14.6666L5.33301 11.9999M11.9997 14.6666L10.6663 11.9999",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgPresentationTrendlineUpFilled);
export default ForwardRef;
